import type { StoreDevice } from './types';

const DEFAULT_DEVICE_ID = 'default';

export const shouldApplyVideoRenderPreferenceQuerySetting = <T>(
    queryValue: T | undefined,
    isMessengerCallIntegration: boolean
): queryValue is T => queryValue !== undefined && isMessengerCallIntegration;

export const resolveStoredJoinDevicePreference = (
    storedValue: boolean | undefined,
    currentValue: boolean,
    isMessengerCallIntegration: boolean
) => (isMessengerCallIntegration || typeof storedValue !== 'boolean' ? currentValue : storedValue);

export function getDeviceLabelOrDefault(device: StoreDevice) {
    return device.deviceId === DEFAULT_DEVICE_ID ? DEFAULT_DEVICE_ID : device.label;
}

export function findDeviceByLabel(devices: StoreDevice[], deviceLabel: Maybe<string>, deviceKind: MediaDeviceKind) {
    return devices.find((device) => {
        return (
            deviceKind === device.kind &&
            (getDeviceLabelOrDefault(device) === deviceLabel || device.label === deviceLabel)
        );
    });
}

export function getDefaultVideoInputDeviceIdFromHost(
    deviceKind: MediaDeviceKind,
    commonDeviceId: string
): Maybe<string> {
    return deviceKind === 'videoinput' && commonDeviceId === DEFAULT_DEVICE_ID ? DEFAULT_DEVICE_ID : undefined;
}
